"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCdnAdaptor = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _useMap3 = _interopRequireDefault(require("./useMap"));

var _CdnAdaptorConfig = require("./CdnAdaptorConfig");

var useCdnAdaptor = function useCdnAdaptor(options) {
  var _useCurrentCdnAdaptor = (0, _CdnAdaptorConfig.useCurrentCdnAdaptor)(options),
      cdnAdaptor = _useCurrentCdnAdaptor.cdnAdaptor;

  var _useMap = (0, _useMap3["default"])(),
      _useMap2 = (0, _slicedToArray2["default"])(_useMap, 2),
      resultMap = _useMap2[0],
      set = _useMap2[1].set;

  return {
    a: _react["default"].useMemo(function () {
      return function (url) {
        var _cdnAdaptor$getHighes;

        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            onError = _ref.onError;

        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (resultMap.has(url)) return resultMap.get(url);
        cdnAdaptor === null || cdnAdaptor === void 0 ? void 0 : cdnAdaptor.getAvailableUrl(url).then(function (_ref2) {
          var _ref3 = (0, _slicedToArray2["default"])(_ref2, 2),
              res = _ref3[0],
              errors = _ref3[1];

          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          res && set(url, res);
          onError && (errors === null || errors === void 0 ? void 0 : errors.forEach(onError));
        });
        return (_cdnAdaptor$getHighes = cdnAdaptor === null || cdnAdaptor === void 0 ? void 0 : cdnAdaptor.getHighestPriorityUrl(url)) !== null && _cdnAdaptor$getHighes !== void 0 ? _cdnAdaptor$getHighes : '';
      };
    }, [cdnAdaptor, resultMap, set]),
    cdnAdaptor: cdnAdaptor
  };
};

exports.useCdnAdaptor = useCdnAdaptor;